// extracted by mini-css-extract-plugin
export var chatHtmlText = "_mt-2";
export var chatLink = "_mt-0";
export var chatText = "_mt-1";